module.exports = __webpack_public_path__ + "img/wechat_code.jpg";